// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ju-3";
export var downloadButton = "_ju-4";
export var fileContainer = "_ju-9 _ju-7";
export var fileContainerBase = "_ju-7";
export var fileContainerFixedHeight = "_ju-8 _ju-7";
export var fileInfo = "_ju-5";
export var fileInfoWidthRestricted = "_ju-6";
export var fileType = "_ju-1";
export var fileTypeName = "_ju-2";
export var image = "_ju-0";
export var link = "_ju-b";
export var overflowEllipsis = "_ju-a";